module.exports = __webpack_public_path__ + "img/ControlParts.8f9c0df6.png";